<template>
  <div>
    <div v-for="message in migration.messages" :key="`msg-${message.id}`" class="flex flex-column mb-5">
      <gg-card>
        <gg-card-header>
          <span class="body-1 fw-bold">{{ message.author }}</span>
          <span class="body-1 fw-bold" style="float:right;">{{ message.date }}</span>
        </gg-card-header>
        <gg-card-text>
          <div v-html="sanitize(message.text)" class="message-white-space"></div>
        </gg-card-text>
      </gg-card>
    </div>
  </div>
</template>

<script>
import DOMPurify from 'dompurify'

export default {
  name: 'MigrationMessagesCard',
  props: {
    migration: {
      type: Object,
      required: true
    }
  },
  methods: {
    sanitize (msg) {
      return DOMPurify.sanitize(msg, { // AM-516
        ALLOWED_TAGS: [ 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
          'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'div',
          'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'u', 'br' ]
      }).replace(/\n\s+\n/g, '\n\n') // replace extra linebreaks
    },
  }
}
</script>

<style scoped>
.message-white-space {
  white-space: pre-line;
  line-height: 1.2rem;
}
</style>
